import { TabHeader } from "components/TabHeader";
import { useState, useEffect } from "react";
import tw, { styled, css } from "twin.macro";
import NotFoundDatas from "components/RFQ/NotFoundDatas/NotFoundDatas";
import { getRFQServices } from "services/guest-flow/rfqServices";
import RfqCard from "components/RFQ/RFQCard/RFQCard";
import RfqCardAnimation from "./RfqCardAnimation";
import { useDispatch } from "react-redux";
import { createRFQ, createRFQTOTAL } from "actions/guestflow/guestRfqActions";
import ModalOverviewComp from "./ModalOverviewComp";
import { useCurrentUser } from "hooks/auth";

function RfqOverview() {
	const { guestUserEmail } = useCurrentUser();
	const [showDialog, setShowDialog] = useState(false);
	const dispatch = useDispatch();
	const SupplierContainer = styled.div(() => [
		tw`relative overflow-hidden px-1`,
		css`
			.buttons-container {
				gap: 8px;
			}
			.container-content {
				padding-right: 24px;
				padding-left: 24px;
			}
		`,
	]);

	const [data, setData] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const abortController = new AbortController();
		const fetchData = async () => {
			try {
				setIsLoading(true);
				const response = await getRFQServices(guestUserEmail, {
					signal: abortController.signal,
				});
				let responseData = response.data.data;
				dispatch(createRFQTOTAL(responseData.length));
				dispatch(createRFQ(responseData));
				setData(responseData);
				setIsLoading(false);
			} catch (error) {
				console.log("error", error);
			}
		};
		fetchData();
		// Clean-up function
		return () => {
			abortController.abort();
		};
	}, [guestUserEmail, dispatch]);

	const acceptTermsFunc = () => {
		setShowDialog(false);
	};

	return (
		<>
			<SupplierContainer>
				<TabHeader
					heading="YOUR RFx"
					description=""
				/>
				<div id="layout-dashboard">
					<div className="mb-6 mt-6">
						{isLoading === true && <RfqCardAnimation />}
						{isLoading === false && (
							<>
								{data?.length < 1 && (
									<div className="flex items-center justify-center">
										<NotFoundDatas text="RFQ Not found" />
									</div>
								)}
								<div
									className="grid w-full min-w-[680px] grid-cols-2 gap-6 xlg:grid-cols-3 3xl:grid-cols-4 4xl:grid-cols-6"
									style={{ marginRight: "20px" }}
									id="scrollable-drawer"
								>
									{data?.map((singleData) => {
										return (
											<RfqCard
												key={singleData?.id}
												data={singleData}
											/>
										);
									})}
								</div>
							</>
						)}
					</div>
				</div>
			</SupplierContainer>
			<div className="translate-y-1/2 overflow-hidden">
				<ModalOverviewComp
					showDialog={showDialog}
					acceptTerms={acceptTermsFunc}
				/>
			</div>
		</>
	);
}

export default RfqOverview;
